import { format, startOfDay } from 'date-fns';
import { flattenDeep } from 'lodash';

type SessionList = {
  [date: string]: MorressierSession[];
};

export const groupSessionsByDay = (sessionList?: SessionList) => {
  const result: SessionList = {};

  if (!sessionList) return result;

  const sessions = flattenDeep(Object.values(sessionList));

  sessions.forEach(session => {
    const startDay = format(startOfDay(new Date(session.start_date)), 'E, MMM d');

    if (result[startDay]) {
      result[startDay].push(session);
    } else {
      result[startDay] = [session];
    }
  });

  return result;
};
